/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  FclP256Verifier,
  FclP256VerifierInterface,
} from "../../../../../../../@safe-global/safe-modules-deployments/dist/assets/safe-passkey-module/v0.2.0/FclP256Verifier";

const _abi = [
  {
    stateMutability: "nonpayable",
    type: "fallback",
  },
] as const;

export class FclP256Verifier__factory {
  static readonly abi = _abi;
  static createInterface(): FclP256VerifierInterface {
    return new Interface(_abi) as FclP256VerifierInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): FclP256Verifier {
    return new Contract(address, _abi, runner) as unknown as FclP256Verifier;
  }
}
